import { render, staticRenderFns } from "./CoPoPsoTimetable.vue?vue&type=template&id=95e8c844"
import script from "./CoPoPsoTimetable.vue?vue&type=script&lang=js"
export * from "./CoPoPsoTimetable.vue?vue&type=script&lang=js"
import style0 from "./CoPoPsoTimetable.vue?vue&type=style&index=0&id=95e8c844&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports